import { BREAKPOINTS } from 'configs/constants';
import { action } from 'mobx';
import UiStore from 'modules/ui/UiStore';

export default class Grid {
  @action
  setDimensions = (event) => {
    const size =
      window?.innerWidth || event?.clientWidth || document?.body?.clientWidth;

    UiStore.gridSize = size;

    if (size < BREAKPOINTS.MD) {
      UiStore.isMobile = true;
      UiStore.sidebarActive = false;
    } else {
      UiStore.isMobile = false;
      UiStore.sidebarActive = true;
    }
  };
}

const grid = new Grid();

grid.setDimensions();

window.addEventListener('resize', grid.setDimensions);
